import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// Component Imports
import Footer from './components/Footer'
import Header from './components/Header'
import SemesterList from './components/SemesterList';
import ClassList from './components/ClassList';
import StudentList from './components/StudentList';
import StudentDetails from './components/StudentDetails';
import ProtectedRoute from './ProtectedRoute';

// Import images
import SemesterTableImg from "./assests/SemestersTable.jpg"
import ClassesTableImg from "./assests/ClassesTable.jpg"
import ImportCSV from "./assests/ImportCSV.jpg"
import ImportedList from "./assests/ImportedList.jpg"
import ExportedAttendance from "./assests/ExportedAttendance.jpg"

function App() {
  const [logInStatus,setLogIn] = useState(false);
  let links = []
  if(logInStatus){
    links = [{text:'Dashboard',to:"/semester-list"}]
  }
  return (
    <div className="d-flex flex-column min-vh-100">
    <Router>
      <Header logo={"Web App Attendance Demo V1"} logInStatus={logInStatus} links={links} logInStatusChanger={setLogIn}/>
      <Routes>
        <Route
          path='/'
          element={
            <div className='container p-1 text-center'>
              <h1>Welcome to this Demo!</h1>
              <p className='text-start'>
                &emsp;This web app is an example of a possible implementation of an Attendance
                app that helped in building within my Software Engineering class in the
                Spring of 2022. And I would like to enphasize that this project is still in an
                incomplete state. And should not be used beyond that of a demonstration of what
                could can done. Note there are also plans to continue this project as well.
              </p>
              <h2>Current Features</h2>
              <h3>Organization</h3>
              <p className="text-start">
                &emsp;This app allows you to orgainize groups of students into semesters and then
                classes. Allowing for clear organization which is useful in later features.
              </p>
              <img style={{width:'15vw', minWidth:"120px"}} src={SemesterTableImg} alt="" />
              <img style={{width:'25vw', minWidth:"200px"}} src={ClassesTableImg} alt="" />
              <h3>Importing and Exporting</h3>
              <p className="text-start">
                &emsp;Using a CSV (spreadsheet) file you can import a class list into the system and
                automatically generate QR codes that can then be used to track attendance. You can
                also export class records as a CSV (spreadsheet) file in order to then use the data
                within other applications. Such as an uploading the attendance records to a online
                class management tool that generates a grade based on attendance.
              </p>
              <img style={{width:'25vw', minWidth:"200px"}} src={ImportCSV} alt="" />
              <img style={{width:'25vw', minWidth:"200px"}} src={ImportedList} alt="" />
              <img style={{width:'25vw', minWidth:"200px"}} src={ExportedAttendance} alt="" />
              <h3>QR Generation</h3>
              <p className="text-start">
                &emsp;QR codes are genrated in a manor that is unquie to the student. And not just
                within that class. Allowing the same QR code to be used for multiple classes if the
                professsors or teachers use the same app.
              </p>
              <h3>Possible Database Integration</h3>
              <p className="text-start">
                &emsp;As it currently stands the implementation of database interactions is done
                using <a href="https://www.npmjs.com/package/json-server">json-server</a> for local testing.
                with the online demo using <a href="https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage">LocalStorage</a>.
                But due to how the system is currently written it is possible to easily migrate it to
                a proper database when the need arrises.
              </p>
            </div>
          }
        />
          <Route path='/assets/demos/web-app-attendance/v1' element={ <Navigate to='/' />} />
        <Route element={<ProtectedRoute logInStatus={logInStatus}/>}>
          <Route
          path='/semester-list'
          element={
            <SemesterList/>
          }
          />
          <Route
          path='/class-list/:semesterid'
          element={
            <ClassList/>
          }
          />
          <Route
          path='/student-list/:classid'
          element={
            <StudentList/>
          }
          />
          <Route
          path='/student-details/:studentid'
          element={
            <StudentDetails/>
          }
          />
        </Route>
      </Routes>
      <Footer></Footer>
    </Router>
    </div>
  );
}

export default App;
